const routes = [
    {
        path: "/library-chairs",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "librarychair_index"
        }
    }
];

export default routes;
